import SelectCustomerWidget from './SelectCustomerWidget';

export default SelectCustomerWidget;
